import DefaultTasks from "../components/Game/Interface/Tasks/default-tasks.json"
import { CustomEvent } from "./CustomEvent"
import { addMinutes, canAdvanceTime, isBefore, TimeConstraint, TimeInterface } from "./Time"

export enum TaskStatus {
    AVAILABLE,
    IN_PROGESS,
    DONE
}

export interface Task {
    name: string,
    description: string,
    duration: number,
    energyCost: number,
    electricCost: number,
    penalty: number,
    status: TaskStatus,
    timeConstraint: TimeConstraint
}


export interface TaskCompletion {
    time: TimeInterface,
    canCancel: boolean,
    taskId?: number,
    eventId?: number,
}


/**
 * Indicates if task can be executed. Conditions are the following:
 *  - Task is undone.
 *  - Task can be done before bedtime.
 *  - Task respects time constraints.
 *  - Player has enough energy.
 * @param task 
 * @param time 
 * @param points 
 * @returns True if the task can be executed. Otherwise, it returns the error message.
 */
export function canExecuteTask(task: Task, time: TimeInterface, points: number, taskInProgress: TaskCompletion | null, event?: CustomEvent): boolean | string {
    if (task.status === TaskStatus.DONE) { return "La tâche est déjà exécutée." }
    if (event && event.triggerTime) { return taskInProgress ? "La tâche est en cours d'exécution." : "Il est trop tard pour exécuter cette tâche." }
    if (!canAdvanceTime(addMinutes(time, task.duration))) { return "Vous n'avez plus le temps pour exécuter cette tâche." }
    
    if (task.energyCost > points) { return "Vous n'avez pas l'énergie pour exécuter cette tâche." }
    if (taskInProgress !== null && JSON.stringify(taskInProgress.time) !== JSON.stringify(addMinutes(time, task.duration))) { return "La tâche est en cours d'exécution." }
    if (!isBefore(time, task.timeConstraint.before)) { return "Il est trop tard pour exécuter cette tâche." }
    if (isBefore(time, task.timeConstraint.after)) { return "Il est trop tôt pour exécuter cette tâche." }
    
    return true;
}


export function createTasks() {
    return DefaultTasks as Task[]
}